import React from 'react';
import { useForm } from 'react-hook-form';
import CrudCreate from '~/components/CrudCreate';
import IInvolvementType from '../interfaces/IInvolvementType';
import Layout from '~/components/Layout';

export default function Create() {     
  const {register, handleSubmit, control, setValue:setFormValue} = useForm<IInvolvementType>();
  const fields = [
      { name: 'name', type: 'string'},
  ];
  
    return(
      <Layout marginLayout={true}>
        <CrudCreate model={'involvement-type'} 
        fields={fields} 
        register={register} 
        handleSubmit={handleSubmit} 
        control={control} 
        messageSuccess={'Involvement type successfully created!'}  
        title={'Add involvement type'}  
        subheader={'Add involvement type'}
        setFormValue={setFormValue} />
      </Layout>
    )
}
